(function () {
  var STORAGE_KEY = 'lvate_handbuch_auth';

  function initHandbuch(section) {
    if (!section || section.dataset.handbuchInit === 'true') {
      return;
    }

    section.dataset.handbuchInit = 'true';

    var configEl = section.parentElement
      ? section.parentElement.querySelector('[data-handbuch-config]')
      : null;

    if (!configEl && section.previousElementSibling && section.previousElementSibling.matches('[data-handbuch-config]')) {
      configEl = section.previousElementSibling;
    }

    var password = '';

    if (configEl) {
      try {
        password = JSON.parse(configEl.textContent).password || '';
      } catch (e) {}
    }

    password = typeof password === 'string' ? password.trim() : '';
    var form = section.querySelector('[data-handbuch-form]');
    var input = section.querySelector('[data-handbuch-input]');
    var error = section.querySelector('[data-handbuch-error]');
    var navLinks = section.querySelectorAll('[data-handbuch-nav]');
    var kapitelSections = section.querySelectorAll('[data-handbuch-kapitel]');

    function unlock() {
      section.classList.add('is-unlocked');
      try {
        sessionStorage.setItem(STORAGE_KEY, password || '1');
      } catch (e) {}
      initNavigation();
    }

    function showError(message) {
      if (!error) {
        return;
      }

      error.textContent = message;
      error.hidden = false;
    }

    function hideError() {
      if (!error) {
        return;
      }

      error.hidden = true;
      error.textContent = '';
    }

    function updateSidebarOffset() {
      var header = document.querySelector('.site-header');
      var headerHeight = header ? header.offsetHeight : 0;
      var topDesktop = headerHeight + 24;
      var topMobile = headerHeight + 8;

      section.style.setProperty('--handbuch-sidebar-top', topDesktop + 'px');
      section.style.setProperty('--handbuch-sidebar-top-mobile', topMobile + 'px');
      section.style.setProperty('--handbuch-scroll-offset', topDesktop + 16 + 'px');
    }

    function revealActiveNavLink(activeLink) {
      var sidebar = section.querySelector('[data-handbuch-sidebar]');
      if (!sidebar || !activeLink) {
        return;
      }

      var nav = sidebar.querySelector('.handbuch__nav');
      var sidebarBody = sidebar.querySelector('.handbuch__sidebar-body');
      var isMobile = window.matchMedia('(max-width: 989px)').matches;

      if (isMobile && nav) {
        var navRect = nav.getBoundingClientRect();
        var linkRect = activeLink.getBoundingClientRect();

        if (linkRect.left < navRect.left) {
          nav.scrollLeft -= navRect.left - linkRect.left + 8;
        } else if (linkRect.right > navRect.right) {
          nav.scrollLeft += linkRect.right - navRect.right + 8;
        }
        return;
      }

      if (!sidebarBody || sidebarBody.scrollHeight <= sidebarBody.clientHeight) {
        return;
      }

      var bodyRect = sidebarBody.getBoundingClientRect();
      var activeRect = activeLink.getBoundingClientRect();

      if (activeRect.top < bodyRect.top) {
        sidebarBody.scrollTop -= bodyRect.top - activeRect.top + 8;
      } else if (activeRect.bottom > bodyRect.bottom) {
        sidebarBody.scrollTop += activeRect.bottom - bodyRect.bottom + 8;
      }
    }

    function openNavGroup(group, open) {
      if (!group) {
        return;
      }

      var toggle = group.querySelector('[data-handbuch-nav-toggle]');
      var shouldOpen = typeof open === 'boolean' ? open : !group.classList.contains('is-open');

      group.classList.toggle('is-open', shouldOpen);

      if (toggle) {
        toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }

      if (section._handbuchPinSidebar) {
        setTimeout(section._handbuchPinSidebar, 220);
      }
    }

    function initPinnedSidebar() {
      var layout = section.querySelector('[data-handbuch-layout]');
      var sidebarCol = section.querySelector('[data-handbuch-sidebar-col]');
      var sidebar = section.querySelector('[data-handbuch-sidebar]');

      if (!layout || !sidebarCol || !sidebar) {
        return null;
      }

      var desktopMq = window.matchMedia('(min-width: 990px)');
      var rafPending = false;

      function resetPinStyles() {
        sidebar.classList.remove('is-pinned', 'is-pinned-bottom');
        sidebar.style.width = '';
        sidebar.style.left = '';
        sidebar.style.top = '';
      }

      function updatePinnedSidebar() {
        if (!desktopMq.matches || !section.classList.contains('is-unlocked')) {
          resetPinStyles();
          return;
        }

        updateSidebarOffset();

        var topOffset = parseFloat(getComputedStyle(section).getPropertyValue('--handbuch-sidebar-top')) || 96;
        var colRect = sidebarCol.getBoundingClientRect();
        var layoutRect = layout.getBoundingClientRect();
        var sidebarHeight = sidebar.offsetHeight;

        resetPinStyles();

        if (colRect.top >= topOffset) {
          return;
        }

        if (topOffset + sidebarHeight >= layoutRect.bottom) {
          sidebar.classList.add('is-pinned-bottom');
          sidebar.style.width = colRect.width + 'px';
          return;
        }

        sidebar.classList.add('is-pinned');
        sidebar.style.width = colRect.width + 'px';
        sidebar.style.left = colRect.left + 'px';
        sidebar.style.top = topOffset + 'px';
      }

      function scheduleUpdate() {
        if (rafPending) {
          return;
        }

        rafPending = true;
        requestAnimationFrame(function () {
          rafPending = false;
          updatePinnedSidebar();
        });
      }

      updatePinnedSidebar();
      window.addEventListener('scroll', scheduleUpdate, { passive: true });

      if (desktopMq.addEventListener) {
        desktopMq.addEventListener('change', scheduleUpdate);
      }

      return scheduleUpdate;
    }

    function syncNavGroups(activeLink) {
      var activeGroup = activeLink ? activeLink.closest('[data-handbuch-nav-group]') : null;

      section.querySelectorAll('[data-handbuch-nav-group]').forEach(function (group) {
        openNavGroup(group, group === activeGroup);
      });
    }

    function setActiveNav(targetId, revealInSidebar) {
      var activeLink = null;

      navLinks.forEach(function (link) {
        var isActive = link.dataset.target === targetId;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
          activeLink = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });

      syncNavGroups(activeLink);

      if (revealInSidebar && activeLink) {
        revealActiveNavLink(activeLink);
      }
    }

    function scrollToKapitel(targetId) {
      var target = section.querySelector('#' + targetId);

      if (!target) {
        return;
      }

      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActiveNav(targetId, false);

      if (history.replaceState) {
        history.replaceState(null, '', window.location.pathname + window.location.search + '#' + targetId);
      }
    }

    function initSearch() {
      var searchModal = section.querySelector('[data-handbuch-search-modal]');
      var searchInput = section.querySelector('[data-handbuch-search-input]');
      var searchOpen = section.querySelector('[data-handbuch-search-open]');
      var searchClose = section.querySelectorAll('[data-handbuch-search-close]');
      var searchHead = section.querySelector('[data-handbuch-search-head]');
      var searchPlaceholder = section.querySelector('[data-handbuch-search-placeholder]');
      var searchResults = section.querySelector('[data-handbuch-search-results]');
      var searchKbd = section.querySelector('[data-handbuch-search-kbd]');

      if (!searchModal || !searchInput || !searchResults) {
        return;
      }

      var searchIndex = [];
      var activeResultIndex = -1;
      var lastFocus = null;

      if (searchKbd) {
        var isMac = /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);
        searchKbd.textContent = isMac ? '⌘K' : 'Ctrl K';
      }

      function escapeHtml(value) {
        return (value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function normalizeText(value) {
        return (value || '')
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim();
      }

      function stripHtml(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
      }

      function getNavMeta(targetId) {
        var link = section.querySelector('[data-handbuch-nav][data-target="' + targetId + '"]');
        var groupEl = link ? link.closest('[data-handbuch-nav-group]') : null;
        var groupToggle = groupEl ? groupEl.querySelector('[data-handbuch-nav-toggle]') : null;
        var groupLabel = groupToggle ? groupToggle.querySelector('.handbuch__nav-group-label') : null;

        return {
          label: link ? link.textContent.trim() : '',
          group: groupLabel ? groupLabel.textContent.trim() : ''
        };
      }

      function buildSearchIndex() {
        searchIndex = [];

        kapitelSections.forEach(function (kapitel) {
          var titleEl = kapitel.querySelector('.handbuch__kapitel-title');
          var bodyEl = kapitel.querySelector('.handbuch__block-body');
          var title = titleEl ? titleEl.textContent.trim() : '';
          var bodyText = bodyEl ? stripHtml(bodyEl.innerHTML) : '';
          var meta = getNavMeta(kapitel.id);

          searchIndex.push({
            targetId: kapitel.id,
            title: title || meta.label,
            label: meta.label,
            group: meta.group,
            haystack: normalizeText([title, meta.label, meta.group, bodyText].join(' ')),
            bodyText: bodyText
          });
        });
      }

      function highlightSnippet(text, terms) {
        var lowerText = text.toLowerCase();
        var matchIndex = -1;
        var matchTerm = '';

        terms.forEach(function (term) {
          var index = lowerText.indexOf(term);
          if (index !== -1 && (matchIndex === -1 || index < matchIndex)) {
            matchIndex = index;
            matchTerm = term;
          }
        });

        if (matchIndex === -1) {
          var fallback = text.slice(0, 110);
          return escapeHtml(fallback) + (text.length > 110 ? '…' : '');
        }

        var start = Math.max(0, matchIndex - 42);
        var end = Math.min(text.length, matchIndex + matchTerm.length + 64);
        var snippet = text.slice(start, end);
        var highlightStart = matchIndex - start;
        var highlightEnd = highlightStart + matchTerm.length;
        var before = escapeHtml(snippet.slice(0, highlightStart));
        var match = escapeHtml(snippet.slice(highlightStart, highlightEnd));
        var after = escapeHtml(snippet.slice(highlightEnd));

        return (start > 0 ? '…' : '') + before + '<mark>' + match + '</mark>' + after + (end < text.length ? '…' : '');
      }

      function resetResultsView() {
        searchResults.innerHTML = '';
        searchResults.hidden = true;

        if (searchHead) {
          searchHead.hidden = true;
          searchHead.textContent = '';
        }

        if (searchPlaceholder) {
          searchPlaceholder.hidden = false;
          searchPlaceholder.textContent =
            'Tippen, um Kapitel zu finden — z. B. „SKU“, „Collection“, „Deep Link“.';
        }

        activeResultIndex = -1;
      }

      function openSearchModal() {
        if (!section.classList.contains('is-unlocked')) {
          return;
        }

        lastFocus = document.activeElement;
        searchModal.hidden = false;
        section.classList.add('is-search-open');
        document.documentElement.classList.add('handbuch-search-open');
        searchInput.value = '';
        resetResultsView();

        requestAnimationFrame(function () {
          searchInput.focus();
        });
      }

      function closeSearchModal() {
        searchModal.hidden = true;
        section.classList.remove('is-search-open');
        document.documentElement.classList.remove('handbuch-search-open');
        searchInput.value = '';
        resetResultsView();

        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus();
        }
      }

      function renderResults(results, terms) {
        searchResults.innerHTML = '';

        if (searchPlaceholder) {
          searchPlaceholder.hidden = true;
        }

        if (!results.length) {
          searchResults.hidden = false;
          searchResults.innerHTML =
            '<li class="handbuch__search-empty">' +
            '<p class="handbuch__search-empty-title">Kein Treffer</p>' +
            '<p class="handbuch__search-empty-text">Andere Begriffe probieren, z. B. „SKU“, „Collection“ oder „Deep Link“.</p>' +
            '</li>';

          if (searchHead) {
            searchHead.hidden = true;
          }

          activeResultIndex = -1;
          return;
        }

        if (searchHead) {
          searchHead.textContent = results.length === 1 ? '1 Treffer' : results.length + ' Treffer';
          searchHead.hidden = false;
        }

        results.slice(0, 10).forEach(function (item) {
          var li = document.createElement('li');
          li.className = 'handbuch__search-result';
          li.innerHTML =
            '<button type="button" class="handbuch__search-result-btn" data-handbuch-search-result data-target="' +
            escapeHtml(item.targetId) +
            '">' +
            '<span class="handbuch__search-result-top">' +
            '<span class="handbuch__search-result-title">' +
            escapeHtml(item.title) +
            '</span>' +
            (item.group ? '<span class="handbuch__search-result-badge">' + escapeHtml(item.group) + '</span>' : '') +
            '</span>' +
            '<span class="handbuch__search-result-snippet">' +
            highlightSnippet(item.bodyText, terms) +
            '</span>' +
            '</button>';
          searchResults.appendChild(li);
        });

        searchResults.hidden = false;
        activateResult(0);
      }

      function runSearch() {
        var query = normalizeText(searchInput.value);

        if (query.length < 1) {
          resetResultsView();
          return;
        }

        if (query.length < 2) {
          if (searchPlaceholder) {
            searchPlaceholder.hidden = false;
            searchPlaceholder.textContent = 'Mindestens 2 Zeichen eingeben…';
          }
          searchResults.hidden = true;
          return;
        }

        if (searchPlaceholder) {
          searchPlaceholder.hidden = true;
        }

        var terms = query.split(' ').filter(Boolean);
        var results = searchIndex.filter(function (item) {
          return terms.every(function (term) {
            return item.haystack.indexOf(term) !== -1;
          });
        });

        results.sort(function (a, b) {
          var aTitle = a.title.toLowerCase().indexOf(terms[0]) !== -1 ? 0 : 1;
          var bTitle = b.title.toLowerCase().indexOf(terms[0]) !== -1 ? 0 : 1;
          return aTitle - bTitle;
        });

        renderResults(results, terms);
      }

      function activateResult(index) {
        var buttons = searchResults.querySelectorAll('[data-handbuch-search-result]');

        if (!buttons.length) {
          activeResultIndex = -1;
          return;
        }

        buttons.forEach(function (button, buttonIndex) {
          button.classList.toggle('is-active', buttonIndex === index);
        });

        activeResultIndex = index;

        if (buttons[index]) {
          buttons[index].scrollIntoView({ block: 'nearest' });
        }
      }

      function openResult(targetId) {
        closeSearchModal();
        scrollToKapitel(targetId);
      }

      buildSearchIndex();

      if (searchOpen) {
        searchOpen.addEventListener('click', openSearchModal);
      }

      searchClose.forEach(function (el) {
        el.addEventListener('click', closeSearchModal);
      });

      searchInput.addEventListener('input', runSearch);

      searchInput.addEventListener('keydown', function (event) {
        var buttons = searchResults.querySelectorAll('[data-handbuch-search-result]');

        if (event.key === 'Escape') {
          event.preventDefault();
          closeSearchModal();
          return;
        }

        if (searchResults.hidden || !buttons.length) {
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activateResult(Math.min(activeResultIndex + 1, buttons.length - 1));
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          activateResult(Math.max(activeResultIndex - 1, 0));
        } else if (event.key === 'Enter') {
          event.preventDefault();
          openResult(buttons[Math.max(activeResultIndex, 0)].dataset.target);
        }
      });

      searchResults.addEventListener('click', function (event) {
        var button = event.target.closest('[data-handbuch-search-result]');

        if (button) {
          openResult(button.dataset.target);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (!section.classList.contains('is-unlocked')) {
          return;
        }

        var isModifier = event.metaKey || event.ctrlKey;

        if (isModifier && event.key.toLowerCase() === 'k') {
          event.preventDefault();

          if (searchModal.hidden) {
            openSearchModal();
          } else {
            closeSearchModal();
          }
        }
      });
    }

    function initNavigation() {
      updateSidebarOffset();
      section._handbuchPinSidebar = initPinnedSidebar();
      initSearch();

      window.addEventListener('resize', function () {
        updateSidebarOffset();

        if (section._handbuchPinSidebar) {
          section._handbuchPinSidebar();
        }
      });

      var header = document.querySelector('.site-header');

      if (header && 'MutationObserver' in window) {
        new MutationObserver(function () {
          updateSidebarOffset();

          if (section._handbuchPinSidebar) {
            section._handbuchPinSidebar();
          }
        }).observe(header, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      navLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          scrollToKapitel(link.dataset.target);
        });
      });

      section.querySelectorAll('[data-handbuch-nav-toggle]').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var group = toggle.closest('[data-handbuch-nav-group]');
          openNavGroup(group);
        });
      });

      if ('IntersectionObserver' in window && kapitelSections.length > 0) {
        var observer = new IntersectionObserver(
          function (entries) {
            var visible = entries.filter(function (entry) {
              return entry.isIntersecting;
            });

            if (!visible.length) {
              return;
            }

            visible.sort(function (a, b) {
              return a.target.offsetTop - b.target.offsetTop;
            });

            setActiveNav(visible[0].target.id, true);
          },
          { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
        );

        kapitelSections.forEach(function (kapitel) {
          observer.observe(kapitel);
        });
      }

      if (window.location.hash) {
        var hashId = window.location.hash.replace('#', '');

        if (section.querySelector('#' + hashId)) {
          setTimeout(function () {
            scrollToKapitel(hashId);
          }, 100);
        }
      } else if (navLinks.length > 0) {
        var sidebarBody = section.querySelector('.handbuch__sidebar-body');

        if (sidebarBody) {
          sidebarBody.scrollTop = 0;
        }

        setActiveNav(navLinks[0].dataset.target, false);
      }
    }

    var isAuthenticated = false;

    try {
      var storedAuth = sessionStorage.getItem(STORAGE_KEY);
      isAuthenticated = !password ? storedAuth === '1' : storedAuth === password;
    } catch (e) {}

    if (!password || isAuthenticated) {
      unlock();
    } else if (form && input) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        hideError();

        if (input.value.trim() === password) {
          unlock();
          input.value = '';
          return;
        }

        showError('Passwort nicht korrekt. Bitte erneut versuchen.');
        input.focus();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-handbuch]').forEach(initHandbuch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-handbuch]');

    if (section) {
      section.dataset.handbuchInit = 'false';
      initHandbuch(section);
    }
  });
})();
